// extracted by mini-css-extract-plugin
export default {"wrapper":"PjKi2nw5XsWF_3oXBFLl","arrowButton":"Qc7sjk8LARoPS57m0uR1","items":"QLtnMnKNdxnMTg1I_TSZ","item":"QtjzIdOUQIQXaPmopMBq","itemActive":"cqZ_5pS9yyg1AahsHcSG"};